import React from 'react';

import './style.css';
import '../../../grid.css';


const FinancingLegal = () => (
    <div className="row">
        <h1 className="section">Financing</h1>
        <p>Payment terms may vary by lender based on system size and price, or credit history.  Financing options are subject to credit approval. Solvana is not a lender and does not guarantee or make any representations concerning the viability, availability, rates, or terms of any loan, lease, or purchase programs quoted by our finance partners, which are independently owned and operated companies. All loan or lease terms are determined and subject to approval by third party lenders.
        </p>
    </div>
);

export default FinancingLegal;



// WEBPACK FOOTER //
// ./src/containers/Legal/FinancingLegal/index.js